'use client';

import { useCallback, useState } from 'react';
import { Box, Stack, Typography, useTheme } from '@mui/material';

export type TourComponentProps = {
  tourUrl?: string;
  onStart?: () => void;
  t: (key: string) => string;
  playIcon: React.ReactNode;
};

export function TourComponent({ tourUrl, onStart, t, playIcon }: TourComponentProps) {
  const { direction } = useTheme();
  const [showOverlay, setShowOverlay] = useState(true);

  const handleClick = useCallback(() => {
    setShowOverlay(false);
    onStart?.();
  }, [onStart]);

  return (
    <Stack
      direction="column"
      width="100%"
      spacing="10px"
      sx={{ padding: { xs: '0 16px', sm: '0' } }}
    >
      <Stack direction="column" spacing={{ xs: '20px', sm: '24px' }}>
        <Stack spacing={{ xs: '8px', sm: '10px' }} direction="column">
          <Typography variant="h5" component="h2">
            {t('labels.interactiveView')}
          </Typography>
        </Stack>

        {tourUrl && (
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: { xs: '475px', sm: '550px' },
              borderRadius: '12px',
              overflow: 'hidden',
            }}
          >
            <Stack
              justifyContent="center"
              alignItems="center"
              sx={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                zIndex: 1,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: showOverlay ? 'flex' : 'none',
                cursor: 'pointer',
              }}
              onClick={handleClick}
            >
              <Stack
                justifyContent="center"
                alignItems="center"
                alignContent="center"
                sx={{
                  color: 'white',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)',
                  padding: '8px 14px',
                  borderRadius: '22px',
                }}
                direction={direction === 'rtl' ? 'row-reverse' : 'row'}
                spacing="10px"
              >
                <Typography
                  lineHeight="30px"
                  fontWeight={600}
                  component="span"
                  sx={{ display: 'inline-block', fontSize: '18px !important' }}
                >
                  {t('labels.startATour')}
                </Typography>
                <Box sx={{ height: '16px', '& svg': { width: '16x', height: '18px' } }}>
                  {playIcon}
                </Box>
              </Stack>
            </Stack>
            <iframe
              src={tourUrl}
              width="100%"
              height="100%"
              allowFullScreen
              style={{
                border: 'none',
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                borderRadius: '12px',
              }}
            />
          </Box>
        )}
      </Stack>
    </Stack>
  );
}
